import React from 'react';
import { tokens, Input, InputOnChangeData, Slot } from '@fluentui/react-components';

type CurrencyInputProps = {
    currency: number | null,
    setCurrencyOrNull?: (Amount: number | null) => void;
    setCurrency?: (Amount: number) => void;
    digits: number;
    ariaInvalid?: boolean | "false" | "true" | "grammar" | "spelling" | undefined;
    contentAfter?: Slot<'span'>;
    AllowNegatifValues?: boolean;
    disabled?: boolean
};

function whatDecimalSeparator() {
    const n = 1.1;
    return n.toLocaleString().substring(1, 2);
}

const sep = whatDecimalSeparator();

export const CurrencyInput: React.FC<CurrencyInputProps> = ({ currency, setCurrency, setCurrencyOrNull, digits, ariaInvalid, contentAfter, AllowNegatifValues, disabled }) => {
    //const InputRef = React.useRef<HTMLInputElement>(null);
    const [amount, setAmount] = React.useState<string>(currency !== null ? (currency === 0 ? "0" : currency.toFixed(digits)) : "");

    return <Input
        //ref={InputRef}
        onChange={(e: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData) => {
            let v = data.value as string;

            // if string is empty
            if (v === '') {
                setAmount("");
                if (setCurrencyOrNull) setCurrencyOrNull(null);
                if (setCurrency) setCurrency(0);
                return;
            }

            // replace with the good separator
            if (sep === ",") {
                const re = /\./gi;
                v = v.replace(re, ",");
            }
            else {
                const re = /,/gi;
                v = v.replace(re, ".");
            }

            //Check if negatif sign
            if ((AllowNegatifValues === undefined || !AllowNegatifValues) && v === "-") {
                setAmount(v);
                return;
            }

            // check number consitency (decimals max is 3)
            const pattern = sep === "," ? /^[-+]?\d+[,]?\d{0,3}$/ : /^[-+]?\d+[.]?\d{0,3}$/;
            if (!pattern.test(v)) {
                e.preventDefault();
                return;
            }

            // check number of decimals
            let p = v.indexOf(".");
            if (p === -1) {
                p = v.indexOf(",");
            }
            if (p !== -1 && v.length > p + digits + 1) {
                const newValue = v.substring(0, p + digits + 1); // +1 = "."
                setAmount(newValue);
                const rounded_n = Number(newValue.replace(sep, "."));
                const rounded_s: string = rounded_n.toFixed(digits);
                const rounded = Number(rounded_s);
                if (setCurrencyOrNull) setCurrencyOrNull(rounded);
                if (setCurrency) setCurrency(rounded);
            }
            else {
                setAmount(v);
                const rounded_n = Number(v.replace(sep, "."));
                const rounded_s: string = rounded_n.toFixed(digits);
                const rounded = Number(rounded_s);
                if (setCurrencyOrNull) setCurrencyOrNull(rounded);
                if (setCurrency) setCurrency(rounded);
            }
        }}
        input={{
            style: { width: "100%" }
        }}
        value={amount === null ? "" : amount}
        aria-invalid={ariaInvalid}
        contentAfter={contentAfter}
        disabled={disabled}
        style={disabled ? {
            color: tokens.colorNeutralForeground1, // text color 
            WebkitTextFillColor: tokens.colorNeutralForeground1, // required for Chrome
            width: "100%"
        } : {
            width: "100%"
        }}
    />;
};